import React, { useMemo } from 'react';
import { Card, CardContent } from '../ui/card';
import { formatCurrency } from '../../lib/formatters';

/**
 * KPI stat tiles for the Deals page (MCA Dark concept: big number, small
 * uppercase label). Pure presentation — computes aggregates from the already
 * loaded deals array, no extra API calls.
 */
const DealsKpiTiles = ({ deals }) => {
  const kpis = useMemo(() => {
    const num = (v) => (typeof v === 'number' && !Number.isNaN(v) ? v : parseFloat(v) || 0);
    const active = deals.filter((d) => d.status === 'Funded' || d.status === 'Payment Issues' || d.status === 'In-House Collection');
    return {
      totalFunded: deals.reduce((s, d) => s + num(d.funding_amount), 0),
      totalOutstanding: active.reduce((s, d) => s + num(d.balance), 0),
      dealCount: deals.length,
      paymentIssues: deals.filter((d) => d.status === 'Payment Issues').length,
      defaults: deals.filter((d) => d.status === 'Default').length,
    };
  }, [deals]);

  const tiles = [
    { label: 'Total Funded', value: formatCurrency(kpis.totalFunded) },
    { label: 'Outstanding Balance', value: formatCurrency(kpis.totalOutstanding) },
    { label: 'Total Deals', value: kpis.dealCount },
    { label: 'Payment Issues', value: kpis.paymentIssues, accent: kpis.paymentIssues > 0 ? 'text-amber-500' : '' },
    { label: 'Defaults', value: kpis.defaults, accent: kpis.defaults > 0 ? 'text-red-500' : '' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-4" data-testid="deals-kpi-tiles">
      {tiles.map((t) => (
        <Card key={t.label}>
          <CardContent className="p-4">
            <p className={`text-2xl font-bold ${t.accent || 'text-gray-900'}`}>{t.value}</p>
            <p className="text-xs uppercase tracking-wide text-gray-500 mt-1">{t.label}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default DealsKpiTiles;
